(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/gametype-folding-fan/assets/javascripts/gametype-folding-fan.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/gametype-folding-fan/assets/javascripts/gametype-folding-fan.js');
"use strict";


const {
  GameCard
} = svs.poker_react.components;
const calculateDefaultPosition = _ref => {
  let {
    index,
    cards,
    offset
  } = _ref;
  const n = cards.length - 1;
  return offset * index - n * offset / 2;
};
const setMargin = (index, cards) => {
  const defaultPosition = calculateDefaultPosition({
    index,
    cards,
    offset: 50
  });
  return defaultPosition * -1;
};
const setRotate = (index, cards) => {
  const defaultPosition = calculateDefaultPosition({
    index,
    cards,
    offset: 3
  });
  return defaultPosition;
};
const setTop = (index, cards) => {
  const defaultPosition = calculateDefaultPosition({
    index,
    cards,
    offset: 20
  });
  return Math.abs(defaultPosition === 0 ? 10 : defaultPosition);
};
const isLastCardOfUnevenList = (index, cards) => {
  const isEvenAmountOfCards = cards.length % 2 === 0;
  return !isEvenAmountOfCards && cards.length - 1 === index;
};
const GametypeFoldingFan = _ref2 => {
  let {
    cards
  } = _ref2;
  return React.createElement("div", {
    className: "gametype-selector"
  }, React.createElement("h3", {
    className: "center-text h2"
  }, "G\xE5 direkt till ditt favoritspel"), React.createElement("div", {
    className: "poker-card-container"
  }, cards && cards.length > 0 && cards.map((card, index) => React.createElement(GameCard, {
    card: card,
    cardsArrLength: cards.length,
    index: index,
    isLastCardOfUnevenList: isLastCardOfUnevenList(index, cards)
    ,
    key: index,
    setMargin: setMargin(index, cards),
    setRotate: setRotate(index, cards),
    setTop: setTop(index, cards)
  }))));
};
setGlobal('svs.poker_react.components.GametypeFoldingFan', GametypeFoldingFan);

 })(window);